(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-search-form/assets/javascripts/casino-search-form-navigation-button.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-search-form/assets/javascripts/casino-search-form-navigation-button.js');

'use strict';

const Button = svs.ui.ReactButton;
const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link;
const CasinoSearchFormNavigationButton = _ref => {
  let link = _ref.link,
    title = _ref.title,
    isActive = _ref.isActive;
  return React.createElement(Button, {
    block: true,
    inverted: isActive,
    size: 100,
    transparent: !isActive
  }, React.createElement(Link, {
    to: link
  }, title));
};
setGlobal('svs.components.casino_react.casinoSearchForm.CasinoSearchFormNavigationButton', CasinoSearchFormNavigationButton);

 })(window);